'use strict';

var angular = require('angular');


module.exports = angular
	.module('flxLandingVideoBackground', [])
	.directive('flxLandingVideoBackground', require('./flxLandingVideoBackgroundDirective'))
	.controller('flxLandingVideoBackgroundController', require('./flxLandingVideoBackgroundController'))
	;